import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Receipt, ExitToApp } from '@material-ui/icons';
import Card from 'src/components/sharedComponents/Card/Card';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import CardTitle from 'src/components/sharedComponents/CardTitle';
// import { urls } from '@auteco/constants';
import { Pagination } from '@material-ui/lab';
import ConfirmModal from 'src/components/insigthFactory/entriesQueue/ConfirmModal';

import {
  CardActions,
  IconButton,
  Typography,
  Tooltip,
  Grid,
  Box,
} from '@material-ui/core';
import {
  Description, styles,
} from './styles';

const EntriesQueue = (props) => {
  const {
    entries,
    totalPages,
    openDialog,
    permitValue,
    handleReject,
    onChangePage,
    onOpenDialog,
    onCloseDialog,
    onChangeInput,
    onEvaluate,
  } = props;
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  return (
    <>
      <ConfirmModal
        openDialog={openDialog}
        handleReject={handleReject}
        onChangeInput={onChangeInput}
        onCloseDialog={onCloseDialog}
      />
      <CardTitle
        title="Entradas Pendientes"
        subTitle="Aceptar y evaluar o rechazar entradas dependiendo de la unidad de negocio"
      />

      {entries.length === 0 && (
        <>
          <Grid justifyContent="center" container>
            <Grid item xs={6}>
              <Card className={classes.emptyContainer}>
                <CardHeader color="customAuteco">
                  <h3>
                    Elige una unidad de negocio o tu unidad no tiene entradas
                    pendientes en este momento
                  </h3>
                  <p>Contacta al administrador </p>
                </CardHeader>
                {/* 
                <ImgWrapper>
                  <Img id="alt" src={urls.DEFAULT_IMG} />
                </ImgWrapper> */}
              </Card>
            </Grid>
          </Grid>
        </>
      )}

      {entries?.map((entry, index) => (
        <Card key={entry.id}>
          <CardHeader color="primary" icon>
            <CardIcon color="customAuteco" className={classes.cardIcon}>
              <Description>{entry.asunto}</Description>
            </CardIcon>
          </CardHeader>
          <CardBody className={classes.cardBody}>
            <Description>{entry.cuerpo}</Description>
            <Box className={classes.dateContainer}>
              <Typography className={classes.date}>
                {entry.fecha_recepcion.slice(0, 10)}
              </Typography>

              <Typography className={classes.date}>
                {entry.remitente}
              </Typography>
            </Box>
          </CardBody>
          {entry.motivo_rechazo ? (
            <CardBody>
              <Box className={classes.rejectContainer}>
                <Typography className={classes.rejectTitle}>
                  Motivo del rechazo:
                </Typography>
                <Typography className={classes.rejectDescription}>
                  {entry.motivo_rechazo}
                </Typography>
              </Box>
            </CardBody>
          ) : null}
          <CardActions>
            {permitValue >= 3 ? (
              <Tooltip title="Evaluar">
                <IconButton onClick={() => onEvaluate(entry.id)}>
                  <Receipt style={{ color: '#4caf50' }} />
                </IconButton>
              </Tooltip>
            ) : null}
            {permitValue >= 3 ? (
              <Tooltip title="Rechazar">
                <IconButton onClick={() => onOpenDialog(index)}>
                  <ExitToApp color="error" />
                </IconButton>
              </Tooltip>
            ) : null}
          </CardActions>
        </Card>
      ))}
      {entries.length === 0 ? null : (
        <Pagination
          count={totalPages}
          onChange={onChangePage}
          defaultPage={1}
        />
      )}
    </>
  );
};

export default EntriesQueue;
